import Axios, { AxiosError } from 'axios';
import { buildResponseError } from '../../../utils/Data/dataUtilities';

export const POST_VALIDATE_ADDRESS_ENDPOINT = '/location/verify-address';

export interface ResponseError {
  error: any;
  status: number;
  data: [];
}

export interface Options {
  withCredentials?: boolean;
  headers?: Headers;
}

export interface ShippingAddress {
  shipAddress1: string;
  shipAddress2: string;
  shipCity: string;
  shipState: string;
  shipZipCode: string;
  shipCountry: string;
  shipPhone: string;
  shipFirstName: string;
  shipLastName: string;
  fffUndeliverable: boolean;
  lobUndeliverable: boolean;
}

export interface AddressValidationRequest {
  primaryLine: string;
  secondaryLine: string;
  city: string;
  state: string;
  countryCode: string;
  zip: string;
}

export const isCallSuccessful = (status: number): boolean => status >= 200 && status < 300;

const sendPost = async (path: string, providedOptions: Options, data: any) => {
  const options = providedOptions;
  options.withCredentials = true;
  return Axios.post(path, data, options).catch((err: AxiosError) => buildResponseError(err));
};

export const postValidateAddress = (
  baseUrl: string,
  addressValidationRequest: AddressValidationRequest,
) => sendPost(
  baseUrl + POST_VALIDATE_ADDRESS_ENDPOINT,
  {},
  addressValidationRequest,
);
